import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const SubheaderTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.contrastText,
}));

export default SubheaderTypography;
